import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserService } from '@app/services/user/user.service';
import { FEATURE_FLAGS } from '@app/infrastructure/feature-flag-manager/feature-flag-list';
import { AnalyticsEvents, AnalyticStatus, MixpanelService } from '@app/services/mixpanel.service';
import { FeatureFlagManagerService } from '@app/infrastructure/feature-flag-manager/feature-flag-manager.service';

@Injectable()
export class EndSessionWarningModalService {
	constructor(
		private userService: UserService,
		private mixpanelService: MixpanelService,
		public featureFlagManagerService: FeatureFlagManagerService,
	) {}

	public continueSession(): Observable<void> {
		return of(null);
		// return from(this.auth.renewToken());
	}

	public endSession(): void {
		if (this.featureFlagManagerService.flags[FEATURE_FLAGS.ENABLE_OPTIMIZATION_HUB]) {
			this.mixpanelService.track(AnalyticsEvents.sessionOver, { Status: AnalyticStatus.timeOut });
		}
		this.userService.logout();
	}
}
